export default __webpack_public_path__ + "static/media/beFTM.8e14abf1.svg";